module.exports = __webpack_public_path__ + "img/pic-02.5c2ffae3.png";